import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import { OffersBlockView } from './OffersBlockView';

export const Offers = Node.create({
    name: 'offers',

    group: 'block',

    defining: true,

    isolating: true,

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
            },
        ];
    },

    renderHTML() {
        return [
            'div',
            {
                'data-type': 'offers',
                class: 'offers-block',
            },
            'Offers Block'
        ];
    },

    addCommands() {
        return {
            setOffers:
                () =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                        });
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(OffersBlockView);
    },
});